import { defineMessages } from 'react-intl';

export default defineMessages({
  language: {
    id: 'cboard.components.Settings.Language.language',
    defaultMessage: 'Language'
  },
  moreLanguages: {
    id: 'cboard.components.Settings.Language.moreLanguages',
    defaultMessage: 'More Languages'
  },
  close: {
    id: 'cboard.components.Settings.Language.close',
    defaultMessage: 'Close'
  },
  ar: {
    id: 'cboard.components.Settings.Language.arabic',
    defaultMessage: 'Arabic'
  },
  be: {
    id: 'cboard.components.Settings.Language.belarusian',
    defaultMessage: 'Belarusian'
  },
  bg: {
    id: 'cboard.components.Settings.Language.bulgarian',
    defaultMessage: 'Bulgarian'
  },
  bn: {
    id: 'cboard.components.Settings.Language.bengali',
    defaultMessage: 'Bengali'
  },
  cs: {
    id: 'cboard.components.Settings.Language.czech',
    defaultMessage: 'Czech'
  },
  da: {
    id: 'cboard.components.Settings.Language.danish',
    defaultMessage: 'Danish'
  },
  de: {
    id: 'cboard.components.Settings.Language.german',
    defaultMessage: 'German'
  },
  el: {
    id: 'cboard.components.Settings.Language.greek',
    defaultMessage: 'Greek'
  },
  en: {
    id: 'cboard.components.Settings.Language.english',
    defaultMessage: 'English'
  },
  es: {
    id: 'cboard.components.Settings.Language.spanish',
    defaultMessage: 'Spanish'
  },
  fi: {
    id: 'cboard.components.Settings.Language.finnish',
    defaultMessage: 'Finnish'
  },
  fr: {
    id: 'cboard.components.Settings.Language.french',
    defaultMessage: 'French'
  },
  he: {
    id: 'cboard.components.Settings.Language.hebrew',
    defaultMessage: 'Hebrew'
  },
  hi: {
    id: 'cboard.components.Settings.Language.hindi',
    defaultMessage: 'Hindi'
  },
  hr: {
    id: 'cboard.components.Settings.Language.croatian',
    defaultMessage: 'Croatian'
  },
  hu: {
    id: 'cboard.components.Settings.Language.hungarian',
    defaultMessage: 'Hungarian'
  },
  id: {
    id: 'cboard.components.Settings.Language.indonesian',
    defaultMessage: 'Indonesian'
  },
  it: {
    id: 'cboard.components.Settings.Language.italian',
    defaultMessage: 'Italian'
  },
  ja: {
    id: 'cboard.components.Settings.Language.japanese',
    defaultMessage: 'Japanese'
  },
  km: {
    id: 'cboard.components.Settings.Language.khmer',
    defaultMessage: 'Khmer'
  },
  ko: {
    id: 'cboard.components.Settings.Language.korean',
    defaultMessage: 'Korean'
  },
  me: {
    id: 'cboard.components.Settings.Language.montenegrin',
    defaultMessage: 'Montenegrin'
  },
  mk: {
    id: 'cboard.components.Settings.Language.macedonian',
    defaultMessage: 'Macedonian'
  },
  ne: {
    id: 'cboard.components.Settings.Language.nepali',
    defaultMessage: 'Nepali'
  },
  nl: {
    id: 'cboard.components.Settings.Language.dutch',
    defaultMessage: 'Dutch'
  },
  no: {
    id: 'cboard.components.Settings.Language.norwegian',
    defaultMessage: 'Norwegian'
  },
  pl: {
    id: 'cboard.components.Settings.Language.polish',
    defaultMessage: 'Polish'
  },
  pt: {
    id: 'cboard.components.Settings.Language.portuguese',
    defaultMessage: 'Portuguese'
  },
  ro: {
    id: 'cboard.components.Settings.Language.romanian',
    defaultMessage: 'Romanian'
  },
  ru: {
    id: 'cboard.components.Settings.Language.russian',
    defaultMessage: 'Russian'
  },
  si: {
    id: 'cboard.components.Settings.Language.sinhala',
    defaultMessage: 'Sinhala'
  },
  sk: {
    id: 'cboard.components.Settings.Language.slovak',
    defaultMessage: 'Slovak'
  },
  sr: {
    id: 'cboard.components.Settings.Language.serbian',
    defaultMessage: 'Serbian'
  },
  sv: {
    id: 'cboard.components.Settings.Language.swedish',
    defaultMessage: 'Swedish'
  },
  th: {
    id: 'cboard.components.Settings.Language.thai',
    defaultMessage: 'Thai'
  },
  tr: {
    id: 'cboard.components.Settings.Language.turkish',
    defaultMessage: 'Turkish'
  },
  tu: {
    id: 'cboard.components.Settings.Language.tetum',
    defaultMessage: 'Tetum'
  },
  uk: {
    id: 'cboard.components.Settings.Language.ukrainian',
    defaultMessage: 'Ukrainian'
  },
  vi: {
    id: 'cboard.components.Settings.Language.vietnamese',
    defaultMessage: 'Vietnamese'
  },
  zh: {
    id: 'cboard.components.Settings.Language.chinese',
    defaultMessage: 'Chinese'
  },
  sq: {
    id: 'cboard.components.Settings.Language.albanian',
    defaultMessage: 'Albanian'
  },
  srme: {
    id: 'cboard.components.Settings.Language.montenegrin',
    defaultMessage: 'Montenegrin'
  },
  ttsEnginesSubheader: {
    id: 'cboard.components.Settings.Language.ttsEnginesSubheader',
    defaultMessage: 'Text to speech engine'
  },
  ttsEngines: {
    id: 'cboard.components.Settings.Language.ttsEngines',
    defaultMessage: 'Text to speech engine'
  },
  ttsEngineError: {
    id: 'cboard.components.Settings.Language.ttsEngineError',
    defaultMessage:
      'WARNING: This text to speech engine does not include any language supported by Cboard!. Feel free to contact us and let us know.'
  },
  availableLangsSubheader: {
    id: 'cboard.components.Settings.Language.availableLangsSubheader',
    defaultMessage: 'Available languages'
  },
  downloadLangSubheader: {
    id: 'cboard.components.Settings.Language.downloadLangSubheader',
    defaultMessage: 'Downloadable languages'
  },
  uninstalled: {
    id: 'cboard.components.Settings.Language.uninstalled',
    defaultMessage: 'Uninstalled'
  },
  download: {
    id: 'cboard.components.Settings.Language.download',
    defaultMessage: 'Download'
  },
  configureLocalVoice: {
    id: 'cboard.components.Settings.Language.configureLocalVoice',
    defaultMessage: 'Configure a local voice'
  },
  downloadDialogTitle: {
    id: 'cboard.components.Settings.Language.downloadDialogTitle',
    defaultMessage: 'Download Language'
  },
  downloadDialogSubtitle: {
    id: 'cboard.components.Settings.Language.downloadDialogSubtitle',
    defaultMessage:
      'You will be redirected to the Google play store in order to download and install the voices for this language. Do you want to proceed?'
  },
  cancel: {
    id: 'cboard.components.Settings.Language.cancel',
    defaultMessage: 'Cancel'
  },
  ttsErrorAlert: {
    id: 'cboard.components.Settings.Language.ttsErrorAlert',
    defaultMessage:
      "We didn't detect the new language is installed. Please verify."
  },
  langErrorAlert: {
    id: 'cboard.components.Settings.Language.langErrorAlert',
    defaultMessage:
      "We didn't detect the new voice is installed. Please verify the downloaded application."
  },
  searchVoiceAlert: {
    id: 'cboard.components.Settings.Language.searchVoiceAlert',
    defaultMessage: 'Please search a voice in the Text To Speech engine app'
  },
  continueOnlineLangAlert: {
    id: 'cboard.components.Settings.Language.continueOnlineLangAlert',
    defaultMessage:
      'An online voice is available for the selected language. If you accept the app would change language automatically.'
  },
  checkIt: {
    id: 'cboard.components.Settings.Language.checkIt',
    defaultMessage: 'Check it'
  },
  CancelInstalation: {
    id: 'cboard.components.Settings.Language.CancelInstalation',
    defaultMessage: 'Cancel instalation'
  },
  openApp: {
    id: 'cboard.components.Settings.Language.openApp',
    defaultMessage: 'Open app'
  },
  uninstalledLangNotification: {
    id: 'cboard.components.Settings.Language.uninstalledLangNotification',
    defaultMessage: 'Install the new language'
  },
  instaledLangSuccesNotification: {
    id: 'cboard.components.Settings.Language.instaledLangSuccesNotification',
    defaultMessage: 'Language installed successfully'
  }
});
